export const loggedOutGoogleAccountKey = 'logged-out-google-account';
export const loggingInDifferentEmailKey = 'logging-in-different-email';
export const loggedOutAppleAccountKey = 'logged-out-apple-account';
